import { useState } from "react";
import emailjs from '@emailjs/browser';

const initialState = {
  name: '',
  email: '',
  message: '',
}
export const Contact = (props) => {
  
  const[{ name, email, message }, setState] = useState(initialState)

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }
  const clearState = () => setState({ ...initialState })

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(name, email, message)
    emailjs
      .sendForm(
        'YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target, 'YOUR_USER_ID'
      )
      .then(
        (result) => {
          console.log(result.text)
          clearState()
        },
        (error) => {
          console.log(error.text)
        }
      )
  }
  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-6 user-part'>
            <h3>Contact Me</h3>
            <div className='contact-item'>
              <div className="contact-inf">
                <div className="inf-icon">
                  <img src="img/email.svg" alt="" />  
                </div>
                <div className="inf-text">
                  <span className="inf-text-label">Email</span>
                  <span className="inf-text-content">{props.data ? props.data.email : 'loading'}</span>
                </div>
              </div>
            </div>
            <div className='contact-item'>
              <div className="contact-inf">
                <div className="inf-icon">
                  <img src="img/location.svg" alt="" />  
                </div>
                <div className="inf-text">
                  <span className="inf-text-label">Address</span>
                  <span className="inf-text-content">{props.data ? props.data.address : 'loading'}</span>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 form-part'>
            <div className='row'>
              <form name='sentMessage' validate="true" onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className="form-label">Full Name</label>
                      <input
                        type='text'
                        id='name'
                        name='name'
                        className='form-control'
                        placeholder='Enter your full name'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className="form-label">Phone Number</label>
                      <input
                        type='text'
                        id='phone'
                        name='phone'
                        className='form-control'
                        placeholder='Enter your phone number'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                <div className='form-group'>
                  <label className="form-label">Email Address</label>
                  <input
                    type='email'
                    id='email'
                    name='email'
                    className='form-control'
                    placeholder='Enter your email address'
                    required
                    onChange={handleChange}
                  />
                </div>
                <div className='form-group'>
                  <label className="form-label">Your Message</label>
                  <textarea
                    name='message'
                    id='message'
                    className='form-control'
                    rows='4'
                    placeholder='Tell us about your project'
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p>
                </div>
                <div id='success'></div>
                <button type='submit' className='btn btn-custom btn-lg'>
                  Send Your Request<img src="img/w_arrow.svg" alt="" style={{paddingLeft: '12px'}}/>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id='footer'>
        <div className='container'>
          <div className="content">
            <div className="footer-logo">
              <img src="img/logo.png" alt="" />
              <span>Gatsby</span>
            </div>
            <div className="footer-menu">
              <ul >
                <li><a href='#portfolio'>Portfolio</a></li>
                <li><a href='#services'>Skills & Experience</a></li>
              </ul>
              <ul>
                <li><a href='#testimonials'>clients</a></li>
                <li><a href='#contact'>Contact</a></li>
              </ul>
            </div>
            <a className="footer-back" href={`#page-top`}>
              <img src="img/back_top.svg" alt="" />
              <span>back to top</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
